import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthpage',
  templateUrl: './unauthpage.component.html',
  styleUrls: ['./unauthpage.component.scss']
})
export class UnauthpageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
